import * as React from 'react';

import { useDispatch } from 'react-redux';

import { PaywallScreens } from '~analytics/types';
import { useDisplayPaywall } from '~teacher/hook/useDisplayPaywall';
import {
  updateGradingWeight,
  updateQuestionImage,
  updateQuestionText,
} from '~teacher/slices/quiz/quizSlice';
import { openPaywall } from '~teacher/slices/teacher/teacherSlice';
import { proCheck } from '~teacher/util/proCheck';

export function useHandleQuestionTextChange() {
  const dispatch = useDispatch();
  return (questionText: string) => {
    dispatch(updateQuestionText({ questionText }));
  };
}

export function useHandleDisplayPaywall() {
  const [displayedPaywalls, setDisplayedPaywalls] = React.useState<
    Set<PaywallScreens>
  >(new Set());
  const dispatch = useDispatch();

  return (paywallScreen: PaywallScreens) => {
    const hasSeenGradeWeightPaywall = displayedPaywalls.has(paywallScreen);
    if (!hasSeenGradeWeightPaywall) return;

    dispatch(
      openPaywall({
        paywallTouch: [paywallScreen],
      })
    );
    setDisplayedPaywalls(displayedPaywalls.add(paywallScreen));
  };
}

export function useHandleChangeWeight() {
  const dispatch = useDispatch();
  const { displayPaywall } = useDisplayPaywall();
  const showAdvancedQuizEditor = proCheck.canShowAdvancedQuizEditor();
  return (gradingWeight: number) => {
    if (!showAdvancedQuizEditor) {
      displayPaywall(PaywallScreens.QuizEditAddGradingWeight);
      return false;
    } else {
      dispatch(
        updateGradingWeight({
          gradingWeight: gradingWeight,
        })
      );

      return true;
    }
  };
}

export function useHandleImageChange() {
  const dispatch = useDispatch();
  return (url: string) => {
    dispatch(updateQuestionImage({ url }));
  };
}
